// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"cf822e02","264":"596a0659","453":"32ad7777","870":"522d7b93"}[chunkId] + ".chunk.js";
};